import { Component } from "@angular/core";
import { ObjectiveMenuList } from "../../data/objective.data";
import { SharedModule } from "src/shared/shared.module";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-introduce",
  imports: [SharedModule, CommonModule, TranslateModule],
  templateUrl: "./introduce.component.html",
  styleUrl: "./introduce.component.scss",
})
export class IntroduceComponent {
  objectiveList = ObjectiveMenuList;
}
